/**
 * Represents a reference to a guide, which could either be a Pendo Guide or User Guide Slug.
 */
interface GuideReference {
  /**
   * The unique identifier for the guide.
   * - For `PENDO`, this is the Pendo Guide ID.
   * - For `USER_GUIDE`, this is a relative path or slug used to construct the guide URL.
   */
  guideId: string;

  guideType: 'PENDO' | 'USER_GUIDE';
}

const GuideReferenceMap: Record<string, GuideReference | undefined> = {
  'guide-txn-allocation-payment': { guideId: '_wjIBgrgETRHBv7NwIvdbX6u5XM', guideType: 'PENDO' },
  'guide-txn-allocation-refund': { guideId: '_wjIBgrgETRHBv7NwIvdbX6u5XM', guideType: 'PENDO' },
  'guide-txn-allocation-invoice': { guideId: '_wjIBgrgETRHBv7NwIvdbX6u5XM', guideType: 'PENDO' },
  'guide-txn-allocation-credit-memo': { guideId: '_wjIBgrgETRHBv7NwIvdbX6u5XM', guideType: 'PENDO' },
  //  "allocation-dialog-2": {guideId: "/recording-a-payment-on-an-invoice", guideType: 'USER_GUIDE'},
};

export default GuideReferenceMap;
